import { ReferenceData } from './reference-data.model';

export class Title extends ReferenceData {

  uniform: boolean;
  jobTypeId: { correlation: string };

  // tslint:disable-next-line:no-any
  constructor(data: any) {
    super(data);

    this.uniform = data.uniform;
    this.jobTypeId = data.jobTypeId;
  }
}
